import React from 'react';
import DiscoverCard from './../../images/discover-card.png';
import SuccessImage from './../../images/success.png'
import {formatPhoneNumber} from './../../constants/merchantData';
import Config from './../../constants/config';

function CardDetails(props) {

  const { cardProductTypeDesc, lastFacntnum, firstName, lastName, billingAddress1, billingAddress2, city_state_pin, encodedCardArt, cardImageName, checkboxfun, uniqueval, alreadyLinked, merchant,emailAddress,homePhoneNumber,primMobileNumber,workPhoneNumber,emailAddress1,emailAddress2 } = props
  const idUniqueData = `multiselect_${uniqueval}`
  const alreadyLinkedCard = (`${alreadyLinked}` == 'true')
  const checkCardImageValue = (value, field) => {
    if(value !== "null" && value !== null && value !== "" && value !== undefined && value !== "undefined") {
      console.log(field, "Flow");
       return true;
    }
     return false;
   }
  return (
    <React.Fragment>
       <div className="row">
       <div className="col-xs-5">
        {alreadyLinkedCard ?
          <label className="checkbox-container multicard-img" for={idUniqueData}>
            {checkCardImageValue(cardImageName, "Card Image Name") ? (<img src={Config.cardImageUrl + cardImageName +".gif"} 
                  intialImage={DiscoverCard} class="image-size-mul Card-button-linked" height="55.3px" alt="Discover Card" />)
              : checkCardImageValue(encodedCardArt, "Card Art") ? (<img src={`data:image/png;base64,${encodedCardArt}`} 
                  intialImage={DiscoverCard} class="image-size-mul Card-button-linked" height="55.3px" alt="Discover Card"/>)
              : (<img src={DiscoverCard} class="Card-button-linked image-size-mul" height="55.3px" width="90px" alt="Discover Card" />)}
            <img src={SuccessImage} className="checkmark-linked"></img>
          </label>
           : 
          <label className="Card-button checkbox-container multicard-img" for={idUniqueData}>
            {checkCardImageValue(cardImageName, "Card Image Name") ? (<img src={Config.cardImageUrl + cardImageName +".gif"} 
                  intialImage={DiscoverCard} class="image-size-mul Card-button-linked" height="55.3px" alt="Discover Card" />)
              : checkCardImageValue(encodedCardArt, "Card Art") ? (<img src={`data:image/png;base64,${encodedCardArt}`} 
                  intialImage={DiscoverCard} class="image-size-mul Card-button-linked" height="55.3px" alt="Discover Card"/>)
              : (<img src={DiscoverCard} class="Card-button-linked image-size-mul" height="55.3px" width="90px" alt="Discover Card" />)}
          <input type={(merchant == "amazon") ? "radio" : "checkbox"} name="cardselect" value={uniqueval} onChange={checkboxfun} id={idUniqueData} />
          <span className={merchant == "amazon" ? "checkmark-circle" : "checkmark"}></span>
          </label>}
       </div>
       <div className="col-xs-7 multicard-discrib">
       <p className="Card-List-Text">{`${cardProductTypeDesc} (${lastFacntnum})`}</p>
          <p class="glassbox-masked">{`${firstName} ${lastName}`}</p>
          <p class="glassbox-masked">{` ${billingAddress1},  ${billingAddress2}`}</p>
          <p class="glassbox-masked">{` ${city_state_pin}`}</p>
		      <p class="glassbox-masked">{` ${emailAddress}`}</p>
          <p class="glassbox-masked">{` ${emailAddress1}`}</p>
          <p class="glassbox-masked">{` ${emailAddress2}`}</p>
          <p class="glassbox-masked">{` ${formatPhoneNumber(homePhoneNumber)}`}</p>
          <p class="glassbox-masked">{` ${formatPhoneNumber(primMobileNumber)}`}</p>
          <p class="glassbox-masked">{` ${formatPhoneNumber(workPhoneNumber)}`}</p>
       </div>
       
       </div>
       <div className="Line2" />
    </React.Fragment>
  );
}

export default CardDetails;
